<template>
    <div class="homeHeader" v-if="userData.id">
        <el-button type="primary" v-if="userData.isSys == 0" @click="getClick" size="mini"
            style="margin-right: 20px;">考生审核</el-button>
        <div style="margin-right: 20px;">{{ userData.orgName || '' }} <span v-if="userData.orgName">-</span> {{
            userData.name || '' }}</div>
        <el-avatar size="small" :src="circleUrl" @click.native="getOpenUserDia"></el-avatar>


        <el-dialog title="用户信息" :visible.sync="userDialogVisible" center show-close custom-class="usertimeDialog"
            width="650px" :before-close="handleClose">
            <div class="mainContent">
                <el-form 
                    :class="{'rule-none-img': !newUserdata.photoUrl}"
                    :model="newUserdata" 
                    ref="ruleForm" 
                    label-width="80px" disabled>
                    <el-form-item label="姓名">
                        <el-input v-model.trim="newUserdata.name" readonly
                            onfocus="this.removeAttribute('readonly');"></el-input>
                    </el-form-item>
                    <el-form-item
                        v-if="newUserdata.pinyin"
                        label="姓名拼音">
                        <el-input v-model.trim="newUserdata.pinyin" readonly
                            onfocus="this.removeAttribute('readonly');"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号">
                        <el-input v-model.trim="newUserdata.idCard" readonly
                            onfocus="this.removeAttribute('readonly');"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码">
                        <el-input v-model.trim="newUserdata.mobile" readonly
                            onfocus="this.removeAttribute('readonly');"></el-input>
                    </el-form-item>
                    <el-form-item label="专业">
                        <el-input v-model.trim="newUserdata.major" readonly
                            onfocus="this.removeAttribute('readonly');"></el-input>
                    </el-form-item>
                    <el-form-item label="就读院校">
                        <el-input v-model.trim="newUserdata.orgName" readonly
                            onfocus="this.removeAttribute('readonly');"></el-input>
                    </el-form-item>
                </el-form>
                <div 
                    v-if="newUserdata.photoUrl"
                    style="text-align: center;">
                    <el-upload
                        class="avatar-uploader"
                        :action="actionUrl"
                        
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload">
                        <img ref="uploadImg" :src="newUserdata.photoUrl" class="avatar">
                    </el-upload>
                    <el-button 
                        class="hover-el"
                        @click="()=>$refs.uploadImg.click()"
                        style="margin-left: 30px; color: black;  text-decoration: underline;"
                        type="text">
                        重新上传
                    </el-button>
                    <el-tooltip placement="bottom">
                        <div slot="content">
                            <div><div class="widget rich_text undefined hleft vtop " style="width: 166px; font-size: 14px; text-align: left; font-weight: normal; font-style: normal;"><div class="rich-text"><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:10px; color:rgba(228,228,228,1); font-style:normal; letter-spacing:0px; line-height:8px; text-decoration:none;">学生照片标准请参照下列要求准备</span></p><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:10px; color:rgba(228,228,228,1); font-style:normal; letter-spacing:0px; line-height:8px; text-decoration:none;">    1.照片格式：jpg、png</span></p><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:10px; color:rgba(228,228,228,1); font-style:normal; letter-spacing:0px; line-height:8px; text-decoration:none;">    2.照片大小：5M 以内</span></p><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:10px; color:rgba(228,228,228,1); font-style:normal; letter-spacing:0px; line-height:8px; text-decoration:none;">    3.照片像素：295*413</span></p><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:10px; color:rgba(228,228,228,1); font-style:normal; letter-spacing:0px; line-height:8px; text-decoration:none;">    4.照片尺寸：2.7cmx3.8cm (宽*长)</span></p><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:10px; color:rgba(228,228,228,1); font-style:normal; letter-spacing:0px; line-height:8px; text-decoration:none;">    5.照片底色:红色</span></p><p style="line-height:0; margin-bottom:5px;"><span class="--mb--rich-text" data-boldtype="0" style="font-family:SourceHanSansSC; font-weight:400; font-size:10px; color:rgba(228,228,228,1); font-style:normal; letter-spacing:0px; line-height:8px; text-decoration:none;"><br></span></p></div></div></div>
                        </div>
                        <span class="el-icon-info" style="margin-left: 5px;"></span>
                    </el-tooltip>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="info" @click="() => { userDialogVisible = false }">取 消</el-button>
                <el-button size="mini" type="danger" @click="confirm">退出登录</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { getStore } from '@/utils/common.js'
import Api from '@/api/fetch.js'
export default {
    name: 'Cheader',
    data() {
        return {
            circleUrl: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            userDialogVisible: false,
            newUserdata: {},
            userData: {}
        }
    },
    watch: {
        userDialogVisible(val) {
            if (val) {
                this.newUserdata = JSON.parse(JSON.stringify(this.userData))
            }
        }
    },
    computed:{
        actionUrl() {
            return process.env.VUE_APP_UPLOAD_API + '/upload/v2Upload'
        },
    },
    methods: {
        handleAvatarSuccess(res) {
            this.newUserdata.photoUrl = res.data.url;
            Api.fixedPhoto({
                id: this.newUserdata.id,
                photoUrl: res.data.url
            })
        },
        handleClose() {
            this.userDialogVisible = false
        },
        getClick() {
            this.$router.push('/audit')
        },
        confirm() {
            sessionStorage.clear()
            this.userDialogVisible = false
            window.location.reload()
        },
        getOpenUserDia() {
            this.userDialogVisible = true
        },
        // 证件照上传前
        beforeAvatarUpload(file) {
            console.log(file);
            let type = file.name.split('.')
            console.log(type);
            if (!['jpg', 'png'].includes(type[type.length - 1])) {
                this.$message.error('图像格式错误，只能上传 jpg / png 格式图片！');
                return false
            }else if(file.size > 5242880 ){
                this.$message.error('图像过大，超出5MB限制！');
                return false
            }
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => {
                    const img = new Image();
                    img.onload = () => {
                        const canvas = document.createElement('canvas');
                        canvas.width = img.width;
                        canvas.height = img.height;
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, img.width, img.height);

                        const imageData = ctx.getImageData(0, 0, img.width, img.height).data;
                        const redPixels = this.countRedPixels(imageData);
                        // 根据实际情况调整判断红底的比例阈值
                        const redRatio = redPixels / (imageData.length / 4);
                        console.log(redRatio);
                        if (redRatio > 0.1) {
                        // 红底判断通过，可以上传
                            this.imageUrl = e.target.result;
                            resolve();
                        } else {
                            this.$message.error('请上传红底图片！');
                            reject();
                        }
                    };

                    img.src = e.target.result;
                };
                reader.readAsDataURL(file);
            });
        },
        countRedPixels(imageData) {
            let redPixels = 0;
            for (let i = 0; i < imageData.length; i += 4) {
                const red = imageData[i];
                const green = imageData[i + 1];
                const blue = imageData[i + 2];
                // 根据实际情况调整判断红底的阈值
                if (red > 100 && green < 100 && blue < 100) {
                    redPixels++;
                }
            }
            return redPixels;
        },
    },
    mounted() {
        this.userData = (JSON.parse(getStore('userData') || '{}')) || {}
        console.log( this.userData, ' this.userData')
    },
}
</script>
<style scoped lang="scss">
.homeHeader {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 40px;
    line-height: 40px;
    background-color: rgba(255, 255, 255, 1);
    padding: 0 10px;
    box-sizing: border-box;

    /deep/.el-form-item__content {
        margin-left: 95px !important;
    }

    /deep/.el-form-item__label {
        padding-right: 0px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        background-color: rgba(243, 245, 247, 1);
    }
}
.mainContent{
    display: flex;
    .el-form{
        width: 450px;
    }
    .rule-none-img{
        width: 100%;
    }
    /deep/ .el-upload{
        margin-left: 30px;
    }
    .avatar{
        width: 120px;
    }
    .hover-el:hover{
        opacity: .7;
    }
}
</style>